<template>
  <TrainerLayout>
    <section class="space-y-4 my-10">
      <h6 class="text-xl font-semibold leading-normal mt-0 mb-4 text-gray-dark">
        My Earnings
      </h6>
      <ul
        class="flex justify-around flex-wrap shadow-md p-4 pb-0 ring-1 ring-gray-300 rounded-md"
      >
        <li class="flex items-center hover:text-gray-light mr-4 mb-4">
          <router-link
            :to="{ name: 'EarningsOverview' }"
            active-class="font-semibold"
          >
            <div
              class="rounded-full flex w-12 h-12 justify-center items-center bg-blue-light mx-auto text-blue-500 hover:bg-gray-darkest"
            >
              <Bar />
            </div>
            <p class="text-center">Overview</p>
          </router-link>
        </li>

        <!-- <li class="flex items-center hover:text-gray-light">
          <router-link
            :to="{ name: 'EarningsHistory' }"
            active-class="font-semibold"
          >
            <div
              class="rounded-full flex w-12 h-12 justify-center items-center bg-blue-light mx-auto text-red-500 hover:bg-gray-darkest"
            >
              <SwitchHorizontal />
            </div>
            <p class="text-center">History</p>
          </router-link>
        </li> -->

        <li class="flex items-center hover:text-gray-light mr-4 mb-4">
          <router-link
            :to="{ name: 'EarningsSession' }"
            active-class="font-semibold"
          >
            <div
              class="rounded-full flex w-12 h-12 justify-center items-center bg-blue-light mx-auto text-pink-500 hover:bg-gray-darkest"
            >
              <Briefcase />
            </div>
            <p class="text-center">Classes</p>
          </router-link>
        </li>

        <li class="flex items-center mr-4 mb-4">
          <router-link
            :to="{ name: 'EarningsSales' }"
            active-class="font-semibold"
          >
            <div
              class="rounded-full flex w-12 h-12 justify-center items-center bg-blue-light mx-auto text-blue-500 hover:bg-gray-darkest"
            >
              <Dollar />
            </div>
            <p class="text-center">Sales</p>
          </router-link>
        </li>

        <li class="flex items-center hover:text-gray-light mr-4 mb-4">
          <router-link
            :to="{ name: 'EarningUsers' }"
            active-class="font-semibold"
          >
            <div
              class="rounded-full flex w-12 h-12 justify-center items-center bg-blue-light mx-auto text-blue-500 hover:bg-gray-darkest"
            >
              <User />
            </div>
            <p class="text-center">Users</p>
          </router-link>
        </li>

        <li class="flex items-center hover:text-gray-light mr-4 mb-4">
          <router-link
            :to="{ name: 'EarningsTips' }"
            active-class="font-semibold"
          >
            <div
              class="rounded-full flex w-12 h-12 justify-center items-center bg-blue-light mx-auto text-red-500 hover:bg-gray-darkest"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 28.5 31.656"
              >
                <g
                  id="Icon_feather-box"
                  data-name="Icon feather-box"
                  transform="translate(-3.75 -2.214)"
                >
                  <path
                    id="Path_1270"
                    data-name="Path 1270"
                    d="M31.5,24V12A3,3,0,0,0,30,9.4l-10.5-6a3,3,0,0,0-3,0L6,9.4A3,3,0,0,0,4.5,12V24A3,3,0,0,0,6,26.595l10.5,6a3,3,0,0,0,3,0l10.5-6A3,3,0,0,0,31.5,24Z"
                    fill="none"
                    stroke="#ce0707"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="1.5"
                  />
                  <path
                    id="Path_1271"
                    data-name="Path 1271"
                    d="M4.905,10.44,18,18.015,31.095,10.44"
                    fill="none"
                    stroke="#ce0707"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="1.5"
                  />
                  <path
                    id="Path_1272"
                    data-name="Path 1272"
                    d="M18,33.12V18"
                    fill="none"
                    stroke="#ce0707"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="1.5"
                  />
                </g>
              </svg>
            </div>
            <p class="text-center">Tips</p>
          </router-link>
        </li>

        <!-- <li class="flex items-center hover:text-gray-light">
          <router-link
            :to="{ name: 'EarningsPayouts' }"
            active-class="font-semibold"
          >
            <div
              class="rounded-full flex w-12 h-12 justify-center items-center bg-blue-light mx-auto text-red-500 hover:bg-gray-darkest"
            >
              <Dollar />
            </div>
            <p class="text-center">Payouts</p>
          </router-link>
        </li> -->

        <!-- <li class="flex items-center hover:text-gray-light">
          <router-link
            :to="{ name: 'EarningsAccount' }"
            active-class="font-semibold"
          >
            <div
              class="rounded-full flex w-12 h-12 justify-center items-center bg-blue-light mx-auto text-red-500 hover:bg-gray-darkest"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 29 29"
              >
                <path
                  id="Icon_material-account-circle"
                  data-name="Icon material-account-circle"
                  d="M17.5,3A14.5,14.5,0,1,0,32,17.5,14.505,14.505,0,0,0,17.5,3Zm0,4.35a4.35,4.35,0,1,1-4.35,4.35A4.344,4.344,0,0,1,17.5,7.35Zm0,20.59a10.441,10.441,0,0,1-8.7-4.669c.043-2.885,5.8-4.466,8.7-4.466s8.656,1.58,8.7,4.466a10.441,10.441,0,0,1-8.7,4.669Z"
                  transform="translate(-3 -3)"
                  fill="#378990"
                />
              </svg>
            </div>
            <p class="text-center">Account</p>
          </router-link>
        </li> -->
      </ul>
      <div>
        <router-view></router-view>
      </div>
    </section>
  </TrainerLayout>
</template>

<script>
import TrainerLayout from "@/components/layouts/TrainerLayout";
import {
  Bar,
  SwitchHorizontal,
  Briefcase,
  Dollar,
  User,
} from "@/components/icons";

export default {
  name: "Earnings",
  components: {
    TrainerLayout,
    Bar,
    SwitchHorizontal,
    Briefcase,
    Dollar,
    User,
  },
  data() {
    return {};
  },
  methods: {},
};
</script>